<template>
  <div class="row mb-4" :class="{'mr-1': allowCardResize}">
    <div class="card card-resizable-policy rounded-3 shadow-sm rounded" :class="cardResizableDynamicClasses">
      <div class="card-header bg-white border-bottom-0 text-secondary py-1">
        <div class="row mx-auto">

          <div class="d-flex justify-content-center rounded rounded-4 pr-2 pl-2 mt-3 mt-md-1" :style="{'position': 'absolute', 'z-index': '100', 'max-width': '14rem', 'background-color': 'rgba(245, 245, 245, 0.65)'}" :class="{'border': isDisplayedSelectedCpaDefined}">
            <div ref="displayed_cpa_detail_div" v-if="isDisplayedSelectedCpaDefined" class="d-flex ml-4 mr-4">
              <div class="d-flex flex-fill justify-content-center ml-2" @mouseover="onMouseOverHeader(displayedSelectedCpa.cpaHead, displayedSelectedCpa.cpaTail)" @mouseleave="onMouseLeaveHeader()" :style="{'max-width': '9rem'}">

                <CellContentDisplayer 
                  :htmlTitle="`CPA ${displayedSelectedCpa.cpaHead}<span class='icon icon-Forward mx-auto' style='font-size: 0.75rem;'></span>${displayedSelectedCpa.cpaTail}`"
                  :cpaIsDefined="true"
                  :cpaLabel="displayedSelectedCpa.cpaLabel"
                  :cpaLink="displayedSelectedCpa.cpaLink"
                  :cpaScore="displayedSelectedCpa.cpaScore"
                  :cpaCoverage="displayedSelectedCpa.cpaCoverage"
                  :isScoresMerged="mergeOptions && mergeOptions.isScoresMerged"
                />

              </div>
            </div>
            <span v-if="displayedSelectedCpa && displayedSelectedCpa.cpaScore" class="icon icon-Modifier-delete clickable" title="close" :style="{'font-size': '1rem', 'position': 'absolute', 'right': '1px'}" @click="unselectCpa()"></span>
          </div>

          <div class="col"></div>
          <h4 class="mb-0">{{ tableContentDisplayerTitle }}</h4>
          <div class="row align-right ml-1 mr-2 my-auto pb-1 pl-1" :class="{'d-none': !mergeOptions || mergeOptions.displayedAsTextTable}">
            <span class="icon icon-zoom-in clickable mr-1" title="Increase table policy" v-on:click="increasePolicySizeClass()"></span>
            <span class="icon icon-zoom-out clickable" title="Reduce table policy" v-on:click="reducePolicySizeClass()"></span>
          </div>
          <div class="col"></div>
          <div class="row align-right ml-1 mr-2 my-auto" :class="{'d-none': !mergeOptions || mergeOptions.displayedAsTextTable}">
            <span class="icon-image icon-image-save-in-cloud clickable mr-1" title="Save additional content" v-on:click="saveAdditionalContent()"></span>
            <span class="icon-image icon-image-delete-in-cloud clickable" title="Delete additional content" v-on:click="removeAdditionalContent()"></span>
          </div>
          <h4 class="icon icon-4G-Cam-Inbox80 align-right mr-2 my-auto" :class="{'d-none': !mergeOptions || !mergeOptions.displayedAsTextTable}" v-on:click="downloadTableContentAsCsv()"></h4>
        </div>
      </div>
      <div class="card-body pt-1" id="mergedAnnotationTablesDisplayerCardBody" :style="{'max-width': allowCardResize ? '90vw' : 'unset'}">
        <div v-if="mergedTableMatrix !== undefined" class="table-responsive table-xs pb-0 pr-2 d-flex" :style="{'max-height': tablesHeight, 'max-width': '90vw'}">

          <AddNewCPAModal v-if="!mergeOptions || !mergeOptions.displayedAsTextTable" :startColumnIndex="columnIndexUsedForNewCPARequest" :startColumn="columnUsedForNewCPARequest" :headerName="headerNameUsedForNewCPARequest" v-on:add-new-column="addColumn($event)" />

          <table ref="displayed_table" class="table mb-0 headerAlwaysVisible">
            <thead>
              <tr ref="displayed_table_cpa_svg_line" rowspan="0">
                <th class="p-0 bg-white" :colspan="mergedTableMatrix.getMaxColumnsLength()">

                  <SvgCPADisplayer
                    :svgWidth="svgWidth"
                    :cpaLineRefsBounds="cpaLineRefsBounds"
                    :svgLeftBorder="svgLeftBorder"
                    :filteredCpaElementsToMerge="filteredCpaElementsToMerge"
                    :hoverCoordinates="hoverCoordinates"
                    :isCpaMerged="this.mergeOptions && this.mergeOptions.isCpaMerged"
                    :svgHoverPoint="svgHoverPoint"
                    v-on:mouse-over-header="onMouseOverHeader($event.column, $event.columnLinked)"
                    v-on:mouse-leave-header="onMouseLeaveHeader()"
                    v-on:select-cpa="selectCpa($event)"
                    v-on:svg-height-updated="updateSvgHeight($event.svgHeight)"
                    :class="{'d-none': ((thCpaDivMinHeight <= 0) || mergeOptions.displayedAsTextTable)}"
                  />

                </th>
              </tr>

              <tr ref="displayed_table_first_line" class="pb-0 mb-0 border-bottom-0" v-for="(line,i) in mergedTableMatrixHeader" :key="'tr-header-names-'+i" :style="{'height': thHeaderDivMinHeight+'px'}">
                <th class="pl-0 pr-0 pb-0" v-for="(element,index) in line" :key="'th-'+index" :class="{'th-header-name': !isElementHiddenByFilter(element)}" :style="{'max-height': thHeaderDivMinHeight+'px'}">
                
                  <div v-if="!isElementHiddenByFilter(element)" class="d-flex flex-fill" :style="{'min-width': getMergedCta(element.initialColumnIndex).ctaScore ? minWidthForThWithCTA : 'auto'}">
                    <div class="d-flex flex-fill justify-content-center ml-1 my-auto" ref="th_header_div" @mouseover="onMouseOverHeader(element.initialColumnIndex)" @mouseleave="onMouseLeaveHeader(element.initialColumnIndex)" :class="{ 'bg-white': element.isAddedColumnsPropertyElement }" >
                      <div class="d-flex flex-column my-auto flex-grow-1" :id="'displayed_table_first_line_th_'+index">
                        <b v-if="hasHeader" class="text-truncate-multiline-2" :title="element.initialText">{{ element.initialText }}</b>
                        <!-- <small v-if="!hasHeader">{{ $t('empty-header') }}</small> -->
                        <small v-if="!hasHeader" class="mx-1 text-truncate" :title="element">{{ element }}</small>
                      </div>
                      <div v-if="!mergeOptions || !mergeOptions.displayedAsTextTable" class="d-flex flex-column my-auto pb-1" >

                        <span data-toggle="dropdown" class="dropdown-toggle align-items-center py-1 px-0 bg-transparent clickable" :class="{'d-none': (!canRequestKnowledgeForNewCPAOnThisMergedTableColumn(index)) && (element.initialColumnIndex === undefined)}">
                        </span>

                        <div data-v-4d6381c2="" class="dropdown-menu dropdown-menu-right mt-1">
                          <div data-v-4d6381c2="" class="dropdown-item px-2 clickable" :class="{'d-none': !canRequestKnowledgeForNewCPAOnThisMergedTableColumn(index)}" >
                            <div class="d-flex justify-content-between align-items-center" data-toggle="modal" data-target="#addNewCPAModal" title="Add new property column" v-on:click="useThisMergedTableColumnForNewCPARequest(index, element.initialText)">
                              <span>Add linked property </span>
                              <span href="#" class="my-auto icon icon-Network-add mx-1 clickable" :style="{'height': 'auto'}">
                              </span>
                            </div>
                          </div>
                          <div data-v-4d6381c2="" class="dropdown-item px-2 clickable" :class="{'d-none': (element.initialColumnIndex === undefined)}" >
                            <div class="d-flex justify-content-between align-items-center" title="Hide this column" v-on:click="hideColumn({initialColumnIndex: element.initialColumnIndex})">
                              <span>Hide this column </span>
                              <span class="my-auto icon icon-accessibility-vision mx-1 clickable" :style="{'height': 'auto'}">
                              </span>
                            </div>
                          </div>
                        </div>
                      
                      </div>
                    </div>
                    <HorizontalResizer :style="{'height': (thHeaderDivMinHeight-10)+'px'}" :data-target-id-to-resize="'displayed_table_first_line_th_'+index"></HorizontalResizer>
                  </div>
                  
                  <div v-if="isElementHiddenByFilter(element)" class="d-flex flex-fill justify-content-center hidden-column clickable" :title="'Show column :\n' + (hasHeader ? element.initialText : element)" v-on:click="unhideColumn({initialColumnIndex: element.initialColumnIndex})">
                    <HorizontalResizer class="mx-0 px-0" :style="{'height': (thHeaderDivMinHeight-10)+'px'}" :data-target-id-to-resize="'displayed_table_first_line_th_'+index" :resizeDisabled="true" ></HorizontalResizer>
                  </div>
                  
                </th>
              </tr>

              <tr class="pb-0 mb-0 border-bottom-0" v-for="(line,i) in mergedTableMatrixHeader" :key="'tr-header-spacer-'+i">
                <th class="pl-0 pr-0 pb-0" v-for="(element,index) in line" :key="'th-'+index">

                  <div v-if="!isElementHiddenByFilter(element)" class="spacer bg-white pt-1" :class="{'d-none': !(mergeOptions && (mergeOptions.isCtaMerged || mergeOptions.isCpaMerged))}" :style="{'color': 'white', 'background-color': 'white !important', 'height': '2px'}">
                  </div>

                  <div v-if="isElementHiddenByFilter(element)" class="spacer bg-white pt-1" :class="{'d-none': !(mergeOptions && (mergeOptions.isCtaMerged || mergeOptions.isCpaMerged))}" :style="{'color': 'white', 'background-color': 'white !important', 'height': '2px'}">
                  </div>

                </th>
              </tr>

              <tr class="pb-0 mb-0 border-bottom-0" v-for="(line,i) in mergedTableMatrixHeader" :key="'tr-header-cpa-'+i" :class="{'d-none': !(mergeOptions && (mergeOptions.isCpaMerged))}">
                <th class="pl-0 pr-0 pb-0" v-for="(element,index) in line" :key="'th-'+index">

                  <div v-if="!isElementHiddenByFilter(element) && !element.isAddedColumnsPropertyElement" ref="displayed_cpa_line" class="d-flex justify-content-center" :initialColumnIndex="element.initialColumnIndex">
                    <div ref="th_cpa_div" class="d-flex flex-row flex-wrap align-content-top pl-1">
                      <span class="icon icon-Link clickable" v-for="(cpa, cpaIndex) in getMergedCpaArray(element.initialColumnIndex)" :key="'cpa-header-div-'+cpaIndex" :title="cpa.cpaLabel"  @mouseover="onMouseOverHeader(cpa.cpaHead, cpa.cpaTail)" @mouseleave="onMouseLeaveHeader(cpa.cpaHead, cpa.cpaTail)" @click="selectCpa(cpa)">
                      </span>
                    </div>
                  </div>

                  <div v-if="!isElementHiddenByFilter(element) && element.isAddedColumnsPropertyElement" class="d-flex justify-content-center">
                    <div ref="th_cpa_div" class="d-flex flex-row flex-wrap align-content-top pl-1">
                    </div>
                  </div>

                  <div v-if="isElementHiddenByFilter(element)" ref="displayed_cpa_line" class="d-flex justify-content-center">
                    <div ref="th_cpa_div" class="d-flex flex-row flex-wrap align-content-top pl-1">
                    </div>
                  </div>

                </th>
              </tr>

              <tr class="pb-0 mb-0 border-bottom-0" v-for="(line,i) in mergedTableMatrixHeader" :key="'tr-header-cta-'+i"  :class="{'d-none': !(mergeOptions && (mergeOptions.isCtaMerged))}">
                <th class="pl-0 pr-0 pb-0" v-for="(element,index) in line" :key="'th-'+index" :class="{'px-0': isElementHiddenByFilter(element)}">
                  <!-- {{ element }} -->
                  <div v-if="!isElementHiddenByFilter(element) && !element.isAddedColumnsPropertyElement" class="d-flex flex-column">
                    <div v-for="(cta, ctaIndex) in [getMergedCta(element.initialColumnIndex)]" :key="'cta-header-div-'+ctaIndex" class="d-flex justify-content-center">
                      <div v-if="cta.ctaScore" class="d-flex" :style="{'min-height': thCtaDivMinHeight+'px'}" :class="{'rounded': displayCtaWithBorder, 'rounded-4': displayCtaWithBorder, 'border': displayCtaWithBorder, 'mx-1': displayCtaWithBorder}">
                        <div ref="th_cta_div" class="d-flex flex-fill justify-content-center ml-2 " @mouseover="onMouseOverHeader(index)" @mouseleave="onMouseLeaveHeader(index)">

                          <CellContentDisplayer 
                            :htmlTitle="`CTA`"
                            :ctaIsDefined="true"
                            :ctaLabel="cta.ctaLabel"
                            :ctaLink="cta.ctaLink"
                            :ctaScore="cta.ctaScore"
                            :ctaCoverage="cta.ctaCoverage"
                            :isScoresMerged="mergeOptions && mergeOptions.isScoresMerged"
                          />

                        </div>
                      </div>
                    </div>
                  </div>

                </th>
              </tr>

            </thead>

            <tr class="spacer">
              <td >
              </td>
            </tr>
<!--
            <tr ref="displayed_table_content_rows" class="shadow-sm" v-for="(line, lineHtmlId) in mergedTableMatrix.getRows().slice(maxNumberOfRowsInPage * (displayedRowsPageNumber-1), (maxNumberOfRowsInPage * displayedRowsPageNumber) + 1)" :key="'tr-'+lineHtmlId">
            -->
            <tr ref="displayed_table_content_rows" class="shadow-sm" v-for="(line, lineHtmlId) in mergedTableMatrix.getRows()" :key="'tr-'+lineHtmlId">
              <td class="border" v-for="(element,index) in line" :key="'td-'+index" :class="{'border-300': !isHeaderLine(element.initialRowIndex), 'border-600': isHeaderLine(element.initialRowIndex), 'custom-small-border-top': isHeaderLine(element.initialRowIndex), 'd-none': isHeaderLine(element.initialRowIndex), 'hoverElement': isHoverElement(line, element.initialRowIndex, element.initialColumnIndex), 'hidden-cell': isElementHiddenByFilter(element)}">

                <div v-if="!isElementHiddenByFilter(element)" @mouseover="onMouseOver(line, element.initialRowIndex, element.initialColumnIndex)" @mouseleave="onMouseLeave(line, element.initialRowIndex, element.initialColumnIndex)" class="pl-auto" :style="{'overflow-wrap': 'break-word'}">
                  <!-- {{ element }} -->
                  <CellContentDisplayer 
                    :initialRowIndex="element.initialRowIndex"
                    :initialText="element.initialText"
                    :ceaIsMerged="element.ceaIsMerged"
                    :ceaIsDefined="element.ceaIsDefined"
                    :ceaLabel="element.ceaLabel"
                    :ceaLink="element.ceaLink"
                    :ceaScore="element.ceaScore"
                    :canRequestKnowledgeGraph="canRequestKnowledgeForThisElement(element)"
                    :knowledgeFoundCeas="element.knowledgeFoundCeas"
                    :isWaitingKnowledgeResult="element.isWaitingKnowledgeResult"
                    :knowledgeGraphResultsColor="knowledgeGraphResultsColor"
                    :displayedAsTextTable="mergeOptions && mergeOptions.displayedAsTextTable" 
                    v-on:find-knowledge-result="findCeas(element, line, element.initialRowIndex, { addedColumnIndex: element.addedColumnsPropertyIndex, initialColumnIndex: element.initialColumnIndex })"
                    v-on:select-knowledge-cpa="selectKnowledgeCpa($event.cpa)"
                    v-on:on-mouse-over-knowledge-cpa="onMouseOverHeader($event.headIndex, $event.tailIndex)"
                    v-on:on-mouse-leave-knowledge-cpa="onMouseLeaveHeader($event.headIndex, $event.tailIndex)"
                    v-on:select-knowledge-result-as-favorite="selectKnowledgeCeaAsFavorite($event.knowledgeFoundCea, element.initialRowIndex, { addedColumnIndex: element.addedColumnsPropertyIndex, initialColumnIndex: element.initialColumnIndex })"
                    v-on:unselect-knowledge-result-as-favorite="unselectKnowledgeCeaAsFavorite($event.knowledgeFoundCea, element.initialRowIndex, { addedColumnIndex: element.addedColumnsPropertyIndex, initialColumnIndex: element.initialColumnIndex })"
                    :isScoresMerged="mergeOptions && mergeOptions.isScoresMerged"
                  />
                </div>

              </td>
            </tr>
          </table>

        </div>

<!--
        <div v-for="(maxRowsLength, maxRowsLengthIndex) in [mergedTableMatrix.getMaxRowsLength()]" :key="'page-navigation-div-'+maxRowsLengthIndex">
-->
        <div>
          <div v-if="enablePagination" class="mt-1 text-right">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="(enableDecreasePageNumber) ? 'currentColor' : 'darkgrey'" class="bi bi-arrow-left-circle mr-2" viewBox="0 0 16 16" :class="{'clickable': enableDecreasePageNumber}" v-on:click="decreasePageNumber()">
              <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="(enableIncreasePageNumber) ? 'currentColor' : 'darkgrey'" class="bi bi-arrow-right-circle mr-2" viewBox="0 0 16 16" :class="{'clickable': enableIncreasePageNumber}" v-on:click="increasePageNumber()">
              <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div v-if="allowCardResize" class="d-flex flex-fill">
      <HorizontalResizer class="my-2" :data-target-id-to-resize="'mergedAnnotationTablesDisplayerCardBody'"></HorizontalResizer>
    </div>
  </div>

</template>
<script>
import CellContentDisplayer from './CellContentDisplayer';
import TableMatrix from '../../../model/TableMatrix';
import HorizontalResizer from '../../global/HorizontalResizer';
import AddNewCPAModal from './AddNewCPAModal.vue';
import SvgCPADisplayer from './SvgCPADisplayer.vue';

import configuredProjectsJobs from './projectsJobs.json';

let beforeMountDate;
let mountingDate;
let mountedDate;
let beforeUpdateDate;
let afterUpdateDate;
const writeExecutionLogs = false;
const logExecutionTime = (str) => {
  if (writeExecutionLogs) {
    console.log(str);
  }
}

export default {
  name: "MergedAnnotationTablesDisplayer",
  components: {
    AddNewCPAModal,
    CellContentDisplayer,
    SvgCPADisplayer,
    HorizontalResizer,
  },
  props: ["tableContentDisplayerTitle", "dataTableMatrixToMerge", "ceaTableMatrixToMerge", "ctaTableMatrixToMerge", "cpaTableMatrixToMerge", "addedColumnsMatrix", "addedColumnsPropertiesMatrix", "addedColumnsProperties", "displayedKnowledgeResults", "mergeOptions", "orientation", "hasHeader", "headerPosition", "maxHeight", "hoverCoordinates", "filterCoordinates", "minCPAScoreForKnowledgeRequest", "knowledgeGraphResultsColor"],
  data() {
    return {
      allowCardResize: true,
      displayCtaWithBorder: true,
      mouseHoverLine: undefined,
      resetFilterOnSameFilterActivated: true,
      cpaLinksMaxHeightInPx: 100,
      cpaLinkHeightInPx: 17,
      cpaLinkWidthInPx: 20,
      thHeaderDivMinHeight: 0,
      thCtaDivMinHeight: 0,
      thCpaDivMinHeight: 0,
      svgWidth: 0,
      svgLeftBorder: 0,
      svgHeight: 0,
      cpaLineRefsBounds: [],
      svgHoverPoint: undefined,
      displayedOffsetsUsed: [],
      selectedCpa: undefined,
//      maxNumberOfRowsInPage: 100,
      maxNumberOfRowsInPage: 75,
      displayedRowsPageNumber: 1,
      columnIndexUsedForNewCPARequest: undefined,
      columnUsedForNewCPARequest: [],
      headerNameUsedForNewCPARequest: undefined,
      // colResizerStartingPointX: 0,
      // colResizerStartWidth: 0,
      policySizeClass: 'lg',
      hiddenElementsFilter: {
        byColumnSelector: [
          // nothing hidden by default
          // { addedColumnIndex: 2 },
          // { initialColumnIndex: 0 },
          // { initialColumnIndex: 1 },
          // { initialColumnIndex: 2 },
          // { initialColumnIndex: 5 },
          // { initialColumnIndex: 10 },
          // { initialColumnIndex: 20 },
        ]
      }
    }
  },
  watch: {
    dataTableMatrixToMerge(val, oldVal) {
      console.log(`[watch] [dataTableMatrixToMerge] update ${(val && oldVal) ? '' : 'with missing value'}`);
    },
    addedColumnsMatrix(val, oldVal) {
      console.log(`[watch] [addedColumnsMatrix] update ${(val && oldVal) ? '' : 'with missing value'}`);
    },
    addedColumnsPropertiesMatrix(val, oldVal) {
      console.log(`[watch] [addedColumnsPropertiesMatrix] update ${(val && oldVal) ? '' : 'with missing value'}`);
    },
    displayedKnowledgeResults(val, oldVal) {
      console.log(`[watch] [displayedKnowledgeResults] update ${(val && oldVal) ? '' : 'with missing value'}`);
    },
  },
  beforeMount() {
    beforeMountDate = new Date();
  },
  mounted() {
    mountingDate = new Date();
    logExecutionTime(`[mounted] [datelogs] beforeMountDate --- ${mountingDate - beforeMountDate} ---> start of mounted`);

    this.initializeHiddenElementsFilter();

    this.updateThHeaderDivMinHeight();
    this.updateThCtaDivMinHeight();
    this.updateThCpaDivMinHeight();
    this.updateSvg();

    mountedDate = new Date();
    logExecutionTime(`[mounted] [datelogs] beforeMountDate --- ${mountedDate - beforeMountDate} ---> end of mounted`);
  },
  updated() {
    const updatingDate = new Date();
    logExecutionTime(`[mounted] [datelogs] beforeUpdateDate --- ${updatingDate - beforeUpdateDate} ---> start of updated`);

    this.updateThHeaderDivMinHeight();
    this.updateThCtaDivMinHeight();
    this.updateThCpaDivMinHeight();
    this.updateSvg();

    afterUpdateDate = new Date();
    logExecutionTime(`[mounted] [datelogs] beforeUpdateDate --- ${afterUpdateDate - beforeUpdateDate} ---> end of updated`);
  },
  beforeUpdate() {
    beforeUpdateDate = new Date();
  },
  computed: {
    minRowIndexDisplayed: function() {
      return (this.maxNumberOfRowsInPage * (this.displayedRowsPageNumber - 1));
    },
    maxRowIndexDisplayed: function() {
      return ((this.maxNumberOfRowsInPage * this.displayedRowsPageNumber) - 1);
    },
    enablePagination: function() {
      return (this.dataTableMatrixToMerge.getMaxRowsLength() > this.maxNumberOfRowsInPage);
    },
    enableDecreasePageNumber: function() {
      return (this.minRowIndexDisplayed > 0);
    },
    enableIncreasePageNumber: function() {
      return (this.maxRowIndexDisplayed < this.dataTableMatrixToMerge.getMaxRowsLength());
    },
    cardResizableDynamicClasses: function() {
      return { 
        "card-resizable-policy-xl" : this.policySizeClass === "xl",
        "card-resizable-policy-lg" : this.policySizeClass === "lg",
        "card-resizable-policy-md" : this.policySizeClass === "md",
        "card-resizable-policy-sm" : this.policySizeClass === "sm",
        "card-resizable-policy-xs" : this.policySizeClass === "xs",
      }
    },
    minWidthForThWithCTA: function() {
      if (this.policySizeClass === "xl") {
        return '215px';
      } else if (this.policySizeClass === "lg") {
        return '200px';
      } else if (this.policySizeClass === "md") {
        return '190px';
      } else if (this.policySizeClass === "sm") {
        return '185px';
      } else {
        return '180px';
      }
    },
    displayedSelectedCpa: function() {
      if (this.mergeOptions && this.mergeOptions.isCpaMerged) {
        return this.selectedCpa;
      } else {
        return undefined;
      }
    },
    isDisplayedSelectedCpaDefined: function() {
      return (this.displayedSelectedCpa && this.displayedSelectedCpa.cpaScore);
    },
    showCpaSvg: function() {
      return this.mergeOptions && this.mergeOptions.isCpaMerged;
    },
    downloadTableMatrix: function() {
      if (!this.mergeOptions || !this.mergeOptions.displayedAsTextTable) {
        return new TableMatrix([]);
      }
      const returnedArray = [];
      this.dataTableMatrixToMerge.getColumns().map((column, columnIndex) => {
        const returnedColumn = [];
        column.forEach((rowInColumn, rowIndexInColumn) => {
          let returnedElement = rowInColumn;
          if ((returnedElement === undefined) || (returnedElement === "")){
            const knowledgeFoundCeas = this.getKnowledgeResult(rowIndexInColumn, { initialColumnIndex: columnIndex });
            if (knowledgeFoundCeas && knowledgeFoundCeas.foundCeas) {
              const favoriteFoundCea = knowledgeFoundCeas.foundCeas.find(foundCea => foundCea.isFavorite);
              if (favoriteFoundCea) {
                returnedElement = favoriteFoundCea.label;
              }
            }
          }
          returnedColumn.push(returnedElement);
        })
        returnedArray.push(returnedColumn);

        // Add linked addedColumnsForThisRow linked with this column index
        this.addedColumnsProperties.forEach((addedColumnsProperty, addedColumnsPropertyIndex) => {
          if (addedColumnsProperty.linkedColumnIndex === columnIndex) {

            const returnedAddedColumn = this.addedColumnsMatrix.getColumn(addedColumnsPropertyIndex).map((addedColumnsMatrixRowValue, addedColumnsMatrixRowIndex) => {
              let returnedElement = addedColumnsMatrixRowValue;
              if ((returnedElement === undefined) || (returnedElement === "")) {
                const knowledgeFoundCeas = this.getKnowledgeResult(addedColumnsMatrixRowIndex, { addedColumnIndex: addedColumnsPropertyIndex });
                if (knowledgeFoundCeas && knowledgeFoundCeas.foundCeas) {
                  const favoriteFoundCea = knowledgeFoundCeas.foundCeas.find(foundCea => foundCea.isFavorite);
                  if (favoriteFoundCea) {
                    returnedElement = favoriteFoundCea.label;
                  }
                }
              }
              return returnedElement;
            });

            returnedArray.push(returnedAddedColumn);            
          }
        });
      })
      const returnedTableMatrix = new TableMatrix(returnedArray);
      returnedTableMatrix.inverse();
      return returnedTableMatrix;
    },
    displayedCeaTableMatrixToMerge: function() {
      return new TableMatrix(this.ceaTableMatrixToMerge.getRows().filter((ceaRow) => {
        return ((ceaRow[0] >= this.minRowIndexDisplayed) && (ceaRow[0] <= this.maxRowIndexDisplayed))
      }));
    },
    mergedTableMatrixHeader: function() {
      const headerRowIndex = this.headerPosition;
      if (headerRowIndex != null && headerRowIndex >= 0) {
        const headerRowToMerge = this.dataTableMatrixToMerge.getRow(headerRowIndex);
        const returnedRow = [];
        const headerRowInAddedColumnsMatrix = this.addedColumnsMatrix.getRow(headerRowIndex);
        headerRowToMerge.forEach((columnInRow, columnIndexInRow) => {
          const cea = this.getMergedCea(headerRowIndex, columnIndexInRow);
          const returnedElement = {
            initialRowIndex: headerRowIndex,
            initialColumnIndex: columnIndexInRow,
            initialText: columnInRow,
            ceaIsMerged: cea.ceaIsMerged,
            ceaIsDefined: cea.ceaIsDefined,
            ceaLabel: cea.ceaLabel,
            ceaLink: cea.ceaLink,
            ceaScore: cea.ceaScore,
          };
          returnedRow.push(returnedElement);

          this.addedColumnsProperties.forEach((addedColumnsProperty, addedColumnsPropertyIndex) => {
            if (addedColumnsProperty.linkedColumnIndex === columnIndexInRow) {

              const returnedElement = {
                isAddedColumnsPropertyElement: true,
                addedColumnsPropertyIndex,
                initialRowIndex: headerRowIndex,
                linkedInitialColumnIndex: columnIndexInRow,
                initialText: headerRowInAddedColumnsMatrix[addedColumnsPropertyIndex],
                ceaIsMerged: false,
                ceaIsDefined: false
              }

              returnedRow.push(returnedElement);
            }
          });
        });
        return [returnedRow];
      } else {
        const defaultHeader = [];
        const maxColumnsLength = this.mergedTableMatrix.getMaxColumnsLength();
        for (let columnId = 0; columnId < maxColumnsLength; columnId +=1) {
          defaultHeader.push(this.$t('empty-header'));
        }
        return [defaultHeader];
      }
    },
    mergedTableMatrixWithoutKnowledgeGraphResultsAndAddedColumnsProperties: function() {
      const returnedArray = [];
      this.dataTableMatrixToMerge.getRows().forEach((row, rowIndex) => {
        if ((rowIndex >= this.minRowIndexDisplayed) && (rowIndex <= this.maxRowIndexDisplayed)) {
          const returnedRow = [];
          row.forEach((columnInRow, columnIndexInRow) => {
            const cea = this.getMergedCea(rowIndex, columnIndexInRow);
            const returnedElement = {
              initialRowIndex: rowIndex,
              initialColumnIndex: columnIndexInRow,
              initialText: columnInRow,
              ceaIsMerged: cea.ceaIsMerged,
              ceaIsDefined: cea.ceaIsDefined,
              ceaLabel: cea.ceaLabel,
              ceaLink: cea.ceaLink,
              ceaScore: cea.ceaScore,
            };
            returnedRow.push(returnedElement);
          });

          returnedArray.push(returnedRow);
        }
      })
      return new TableMatrix(returnedArray);
    },
    mergedTableMatrixWithoutKnowledgeGraphResults: function() {
      const returnedArray = [];
      this.mergedTableMatrixWithoutKnowledgeGraphResultsAndAddedColumnsProperties.getColumns().map((column, columnIndex) => {
        const returnedColumn = [];
        column.forEach((rowElementInColumn) => {
          const returnedElement = { ...rowElementInColumn };
          returnedColumn.push(returnedElement);
        })
        returnedArray.push(returnedColumn);

        // Add linked addedColumnsForThisRow linked with this column index
        
        this.addedColumnsProperties.forEach((addedColumnsProperty, addedColumnsPropertyIndex) => {
          if (addedColumnsProperty.linkedColumnIndex === columnIndex) {

            const returnedAddedColumn = this.addedColumnsMatrix.getColumn(addedColumnsPropertyIndex)
            .filter((addedColumnsMatrixRowValue, addedColumnsMatrixRowIndex) => {
              return ((addedColumnsMatrixRowIndex >= this.minRowIndexDisplayed) && (addedColumnsMatrixRowIndex <= this.maxRowIndexDisplayed))
            })
            .map((addedColumnsMatrixRowValue, addedColumnsMatrixRowIndex) => {
              const returnedElement = {
                isAddedColumnsPropertyElement: true,
                addedColumnsPropertyIndex,
                initialRowIndex: addedColumnsMatrixRowIndex + this.minRowIndexDisplayed,
                linkedInitialColumnIndex: columnIndex,
                initialText: addedColumnsMatrixRowValue,
                ceaIsMerged: false,
                ceaIsDefined: false
              }
              return returnedElement;
            });
            returnedArray.push(returnedAddedColumn);
          }
        });
      })
      const returnedTableMatrix = new TableMatrix(returnedArray);
      returnedTableMatrix.inverse();
      return returnedTableMatrix;
    },
    mergedTableMatrix: function() {
      const returnedArray = [];
      this.mergedTableMatrixWithoutKnowledgeGraphResults.getRows().forEach((row, rowIndex) => {
        const returnedRow = [];
        row.forEach((columnInRow) => {
          const returnedElement = { ...columnInRow };
          if (this.canRequestKnowledgeForThisElement(returnedElement)) {
            if (returnedElement.isAddedColumnsPropertyElement) {
                // try to find the already known knowledgeFoundCeas
                const knowledgeFoundCeas = this.getKnowledgeResult(rowIndex + this.minRowIndexDisplayed, { addedColumnIndex: returnedElement.addedColumnsPropertyIndex });
                returnedElement.knowledgeFoundCeas = knowledgeFoundCeas ? knowledgeFoundCeas.foundCeas : undefined;
                returnedElement.isWaitingKnowledgeResult = knowledgeFoundCeas ? knowledgeFoundCeas.isWaitingKnowledgeResult : false;
            } else {
              // try to find the already known knowledgeFoundCeas
              const knowledgeFoundCeas = this.getKnowledgeResult(rowIndex + this.minRowIndexDisplayed, { initialColumnIndex: returnedElement.initialColumnIndex });
              returnedElement.knowledgeFoundCeas = knowledgeFoundCeas ? knowledgeFoundCeas.foundCeas : undefined;
              returnedElement.isWaitingKnowledgeResult = knowledgeFoundCeas ? knowledgeFoundCeas.isWaitingKnowledgeResult : false;
            }
          }
          returnedRow.push(returnedElement);
        });
        returnedArray.push(returnedRow);
      })
      return new TableMatrix(returnedArray);
    },
    tablesHeight: function() {
      if (this.maxHeight === undefined) {
        let returnedHeight = 350;
        if (this.mergeOptions && this.mergeOptions.isCtaMerged) {
          returnedHeight += this.thCtaDivMinHeight;
        }
        if (this.mergeOptions && this.mergeOptions.isCpaMerged) {
          returnedHeight += this.thCpaDivMinHeight + this.svgHeight;
        }
        if (this.mergeOptions && this.mergeOptions.isCeaMerged && this.mergeOptions.isCtaMerged && this.mergeOptions.isCpaMerged) {
          // Add bonus height
          returnedHeight += 90;
        }
        return returnedHeight + 'px';
      } else {
        return this.maxHeight;
      }
    },
    cpaLinkWidth: function() {
      return this.cpaLinkWidthInPx + 'px';
    },
    filteredCpaElementsToMerge: function() {
      if (this.mergeOptions && this.mergeOptions.isCpaMerged) {
        const returnedCpaArray = this.cpaTableMatrixToMerge.getRows().map((cpaFiltered) => {
          return {
            cpaIsDefined: cpaFiltered ? ((cpaFiltered[2] !== undefined) && (cpaFiltered[4] !== undefined) && (cpaFiltered[5] !== undefined) && (cpaFiltered[0] !== undefined) && (cpaFiltered[1] !== undefined)) : false,
            cpaLabel: cpaFiltered[3],
            cpaLink: cpaFiltered[2],
            cpaScore: cpaFiltered[4],
            cpaCoverage: cpaFiltered[5],
            cpaHead: cpaFiltered[0],
            cpaTail: cpaFiltered[1]
          };
        }).filter((element) => {
          return !this.isElementHiddenByFilter({ initialColumnIndex: element.cpaHead }) && !this.isElementHiddenByFilter({ initialColumnIndex: element.cpaTail })
        });
        return returnedCpaArray;
      } else {
        return [];
      }
    },
    selectedProjectName: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.name : undefined;
    },
  },
  created() {
    this.refreshTableWidth = () => {
      this.updateSvg();
    }
    window.addEventListener("resize", this.refreshTableWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.refreshTableWidth);
  },
  methods: {
    addColumn: function (event) {
      console.log("[addColumn] -~~-> add-new-property-column");
      this.$emit('add-new-property-column', event);
    },
    unhideColumn: function (columnSelector) {
      this.hiddenElementsFilter.byColumnSelector = this.hiddenElementsFilter.byColumnSelector.filter((hiddenColumnSelector) => {
        return !this.areSameColumnSelectors(hiddenColumnSelector, columnSelector);
      })
    },
    hideColumn: function (columnSelector) {
      this.hiddenElementsFilter.byColumnSelector.push(columnSelector)
    },
    initializeHiddenElementsFilter: function() {
      console.log(`[initializeHiddenElementsFilter] this.selectedProjectName = ${JSON.stringify(this.selectedProjectName)}`)
      const configuredActualProjectJobs = configuredProjectsJobs.find((configuredProjectJobs) => {
        return (this.selectedProjectName !== undefined) && (configuredProjectJobs.projectSelector !== undefined) && (configuredProjectJobs.projectSelector.projectName === this.selectedProjectName);
      });
      if ((configuredActualProjectJobs !== undefined) && (configuredActualProjectJobs.configuredHiddenElementsFilters !== undefined)) {
        const configuredHiddenElementsFilters = { ...configuredActualProjectJobs.configuredHiddenElementsFilters };
        // Make a copy of configuredHiddenElementsFilters.byColumnSelector in calculatedHiddenElementsFilter.byColumnSelector
        const calculatedHiddenElementsFilter = {
          byColumnSelector: Array.isArray(configuredHiddenElementsFilters.byColumnSelector) ? configuredHiddenElementsFilters.byColumnSelector.map(a => JSON.parse(JSON.stringify(a))) : []
        };
        const configuredColumnHeaderNameFilters = Array.isArray(configuredHiddenElementsFilters.byColumnHeaderName) ? configuredHiddenElementsFilters.byColumnHeaderName : [];
        if ((this.mergedTableMatrixHeader.length === 1) && (Array.isArray(this.mergedTableMatrixHeader[0]))) {

          this.mergedTableMatrixHeader[0].forEach((headerElement) => {
            if ((headerElement !== undefined) && (headerElement.initialText !== undefined)) {
              if (headerElement.initialText !== undefined) {
                if (configuredColumnHeaderNameFilters.includes(headerElement.initialText)) {
                  const columnSelectorToInclude = { initialColumnIndex: headerElement.initialColumnIndex };
                  let isElementAlreadyHidden = false;
                  calculatedHiddenElementsFilter.byColumnSelector.forEach((hiddenElementColumnSelector) => {
                    if (isElementAlreadyHidden === false) {
                      isElementAlreadyHidden = this.areSameColumnSelectors(hiddenElementColumnSelector, columnSelectorToInclude);
                    }
                  })
                  if (!isElementAlreadyHidden) {
                    calculatedHiddenElementsFilter.byColumnSelector.push(columnSelectorToInclude);
                  }
                }
              }
            }
          });
        }          
        if (JSON.stringify(this.hiddenElementsFilter) !== JSON.stringify(calculatedHiddenElementsFilter)) {
          this.hiddenElementsFilter = calculatedHiddenElementsFilter;
        }
      }
    },
    canRequestKnowledgeForNewCPAOnThisMergedTableColumn: function(mergedTableColumnIndex) {
      // console.log("[canRequestKnowledgeForNewCPAOnThisMergedTableColumn] columnIndex = ", columnIndex);
      const canRequestKnowledgeForNewCPAOnThisMergedTableColumnValue = (this.mergedTableMatrix.getColumn(mergedTableColumnIndex).find(elem => ((elem !== undefined) && (elem.ceaIsDefined === true))));
      return (canRequestKnowledgeForNewCPAOnThisMergedTableColumnValue !== undefined);
    },
    useThisMergedTableColumnForNewCPARequest: function(mergedTableColumnIndex, headerName) {
      const returnedArray = [];
      let initialColumnIndex = mergedTableColumnIndex;
      this.mergedTableMatrix.getColumn(mergedTableColumnIndex).filter(a => (a.ceaIsDefined === true)).sort((a, b) => {
        if (a.ceaScore > b.ceaScore) {
          return -1;
        } else if (a.ceaScore < b.ceaScore) {
          return 1;
        } else {
          return 0;
        }
      }).forEach(elem => {
        initialColumnIndex = elem.initialColumnIndex;
        if (returnedArray.length < 5) {
          if (returnedArray.find(a => (a.ceaLink === elem.ceaLink)) === undefined) {
            returnedArray.push(elem)
          }
        }
      });
      console.log("[useThisMergedTableColumnForNewCPARequest] mergedTableColumnIndex = ", JSON.stringify(mergedTableColumnIndex));
      console.log("[useThisMergedTableColumnForNewCPARequest] headerName = ", JSON.stringify(headerName));
      console.log("[useThisMergedTableColumnForNewCPARequest] returnedArray = ", JSON.stringify(returnedArray));
      this.columnIndexUsedForNewCPARequest = initialColumnIndex;
      this.columnUsedForNewCPARequest = returnedArray;
      this.headerNameUsedForNewCPARequest = headerName;
    },
    isFavoriteKnowledgeFoundCea: function(element, knowledgeFoundCea) {
      const favoriteKnowledgeFoundCea = element.knowledgeFoundCeas.filter(foundCeaToFilter => (foundCeaToFilter.isFavorite === true))
      if ((favoriteKnowledgeFoundCea !== undefined) && (favoriteKnowledgeFoundCea.length === 1)) {
        // check if knowledgeFoundCea is the favorite one
        return ((knowledgeFoundCea.label === favoriteKnowledgeFoundCea[0].label) && (knowledgeFoundCea.uri === favoriteKnowledgeFoundCea[0].uri));
      } else {
        return false;
      }
    },
    selectKnowledgeCeaAsFavorite: function(knowledgeFoundCea, lineIndex, columnSelector) {
      console.log("[selectKnowledgeCeaAsFavorite] -~~-> select-favorite-knowledge-graph-result");
      this.$emit('select-favorite-knowledge-graph-result', {knowledgeFoundCea, lineIndex, columnSelector});
    },
    unselectKnowledgeCeaAsFavorite: function(knowledgeFoundCea, lineIndex, columnSelector) {
      console.log("[unselectKnowledgeCeaAsFavorite] -~~-> unselect-favorite-knowledge-graph-result");
      this.$emit('unselect-favorite-knowledge-graph-result', {knowledgeFoundCea, lineIndex, columnSelector});
    },
    canRequestKnowledgeForThisElement: function(element) {
      return (element !== undefined) && (element.initialText === '') && (element.ceaLabel === undefined) && (element.ceaLink === undefined) && (element.ceaScore === undefined);
    },
    areSameColumnSelectors: function(columnSelector1, columnSelector2) {
      if ((columnSelector1 === undefined) || (columnSelector2 === undefined)) {
        return false
      } else if ((columnSelector1.addedColumnIndex !== undefined) && (columnSelector1.initialColumnIndex === undefined)) {
        return ((columnSelector2.initialColumnIndex === undefined) && (columnSelector1.addedColumnIndex === columnSelector2.addedColumnIndex));
      } else if ((columnSelector1.initialColumnIndex !== undefined) && (columnSelector1.addedColumnIndex === undefined)) {
        return ((columnSelector2.addedColumnIndex === undefined) && (columnSelector1.initialColumnIndex === columnSelector2.initialColumnIndex));
      } else {
        return false;
      }
    },
    getKnowledgeResult: function(lineIndex, columnSelector) {
      const returnedKnowledgeResult = this.displayedKnowledgeResults.filter(displayedKnowledgeResult => {
        return ((displayedKnowledgeResult.lineIndex === lineIndex) && this.areSameColumnSelectors(displayedKnowledgeResult.columnSelector, columnSelector));
      });
      if (returnedKnowledgeResult.length === 1) {
        return returnedKnowledgeResult[0];
      } else {
        return undefined;
      }
    },
    findCeas: function(givenElement, line, lineIndex, columnSelector) {
      console.log("[findCeas] -~~-> find-knowledge-graph-results");
      console.log("[findCeas] givenElement = ", givenElement);
      console.log("[findCeas] line = ", line);
      console.log("[findCeas] lineIndex = ", lineIndex);
      console.log("[findCeas] columnIndex = ", columnSelector);
      this.$emit('find-knowledge-graph-results', {givenElement, line, lineIndex, columnSelector});
    },
    decreasePageNumber: function() {
      if (this.minRowIndexDisplayed > 0) {
        this.displayedRowsPageNumber -= 1;
      }
    },
    increasePageNumber: function() {
      if (this.maxRowIndexDisplayed < this.dataTableMatrixToMerge.getMaxRowsLength()) {
        this.displayedRowsPageNumber += 1;
      }
    },
    selectKnowledgeCpa: function(cpa) {
      console.log("[selectKnowledgeCpa] cpa = ", JSON.stringify(cpa));
      if ((cpa !== undefined) && (this.selectedCpa !== undefined) && (cpa.headIndex === this.selectedCpa.cpaHead) && (cpa.tailIndex === this.selectedCpa.cpaTail)) {
        // second click on this CPA -> remove selectedCpa
        this.unselectCpa(); 
      } else {
        this.unselectCpa();
        // only for animation execution
        setTimeout(() => {
          let updatedSelectedCpas = this.cpaTableMatrixToMerge.getRows().filter((cpaRow) => {
            return (((cpaRow[0] === cpa.headIndex) && (cpaRow[1] === cpa.tailIndex)) || ((cpaRow[1] === cpa.headIndex) && (cpaRow[0] === cpa.tailIndex)))
          }).map((cpaFiltered) => {
            return {
              cpaIsDefined: cpaFiltered ? ((cpaFiltered[2] !== undefined) && (cpaFiltered[4] !== undefined) && (cpaFiltered[5] !== undefined) && (cpaFiltered[0] !== undefined) && (cpaFiltered[1] !== undefined)) : false,
              cpaLabel: cpaFiltered[3],
              cpaColumn: (cpaFiltered[0] === cpa.headIndex) ? cpaFiltered[0] : cpaFiltered[1],
              cpaLinkedColumn: (cpaFiltered[0] === cpa.headIndex) ? cpaFiltered[1] : cpaFiltered[0],
              cpaLink: cpaFiltered[2],
              cpaScore: cpaFiltered[4],
              cpaCoverage: cpaFiltered[5],
              cpaHead: cpaFiltered[0],
              cpaTail: cpaFiltered[1]
            };
          });
          if (updatedSelectedCpas.length === 1) {
            this.selectedCpa = updatedSelectedCpas[0];
          } else {
            this.unselectCpa();
          }
        });
      }
    },
    selectCpa: function(cpa) {
      console.log("[selectCpa] cpa = ", JSON.stringify(cpa));
      if ((cpa !== undefined) && (this.selectedCpa !== undefined) && (cpa.cpaHead === this.selectedCpa.cpaHead) && (cpa.cpaTail === this.selectedCpa.cpaTail)) {
        // second click on this CPA -> remove selectedCpa
        this.unselectCpa(); 
      } else {
        this.unselectCpa();
        // only for animation execution
        setTimeout(() => {
          this.selectedCpa = cpa;
        });
      }
    },
    unselectCpa: function() {
      this.selectedCpa = undefined;
    },
    getMergedCea: function(rowIndex, columnIndexInRow) {
      if (this.mergeOptions) {
        const matchingCea = this.displayedCeaTableMatrixToMerge.getRows().filter((ceaRow) => {
          return ( (ceaRow[0] === rowIndex) && (ceaRow[1] === columnIndexInRow) )
        })[0];
        const returnedCeaObject = {
          ceaIsMerged: this.mergeOptions.isCeaMerged,
          ceaIsDefined: matchingCea ? (matchingCea[2] && matchingCea[4] && true) : false,
          ceaLabel: matchingCea ? matchingCea[3] : undefined,
          ceaLink: matchingCea ? matchingCea[2] : undefined,
          ceaScore: matchingCea ? matchingCea[4] : undefined
        }
        return returnedCeaObject;
      } else {
        return {
          ceaIsDefined: false
        };
      }
    },
    getMergedCta: function(columnIndexInRow) {
      if (this.mergeOptions && this.mergeOptions.isCtaMerged) {
        const matchingCta = this.ctaTableMatrixToMerge.getRows().filter((ctaRow) => {
          return (ctaRow[0] === columnIndexInRow)
        })[0];
        const returnedCtaObject = {
          ctaIsDefined: matchingCta ? ((matchingCta[1] !== undefined) && (matchingCta[3] !== undefined) && (matchingCta[4] !== undefined)) : false,
          ctaLabel: matchingCta ? matchingCta[2] : undefined,
          ctaLink: matchingCta ? matchingCta[1] : undefined,
          ctaScore: matchingCta ? matchingCta[3] : undefined,
          ctaCoverage: matchingCta ? matchingCta[4] : undefined,
        }
        return returnedCtaObject;
      } else {
        return {
          ctaIsDefined: false
        };
      }
    },
    getMergedCpaArray: function(columnIndexInRow) {
      if (this.mergeOptions && this.mergeOptions.isCpaMerged) {
        const returnedCpaArray = this.cpaTableMatrixToMerge.getRows().filter((cpaRow) => {
          return ((cpaRow[0] === columnIndexInRow) || (cpaRow[1] === columnIndexInRow))
        }).map((cpaFiltered) => {
          return {
            cpaIsDefined: cpaFiltered ? ((cpaFiltered[2] !== undefined) && (cpaFiltered[4] !== undefined) && (cpaFiltered[5] !== undefined) && (cpaFiltered[0] !== undefined) && (cpaFiltered[1] !== undefined)) : false,
            cpaLabel: cpaFiltered[3],
            cpaColumn: (cpaFiltered[0] === columnIndexInRow) ? cpaFiltered[0] : cpaFiltered[1],
            cpaLinkedColumn: (cpaFiltered[0] === columnIndexInRow) ? cpaFiltered[1] : cpaFiltered[0],
            cpaLink: cpaFiltered[2],
            cpaScore: cpaFiltered[4],
            cpaCoverage: cpaFiltered[5],
            cpaHead: cpaFiltered[0],
            cpaTail: cpaFiltered[1]
          };
        }).filter((element) => {
          return !this.isElementHiddenByFilter({ initialColumnIndex: element.cpaHead }) && !this.isElementHiddenByFilter({ initialColumnIndex: element.cpaTail })
        });
        return returnedCpaArray;
      } else {
        return [];
      }
    },
    updateSvg: function() {
      // Only update SVG Size, SVG left border and CPALineRefsBounds
      // to launch SVG Update by computed variables
      this.updateSvgSize();
      this.updateSvgLeftBorder();
      this.updateCpaLineRefsBounds();
    },
    updateSvgSize: function() {
      let calculatedSvgWidth = this.svgWidth;
      if (this.$refs.displayed_table !== undefined) {
        calculatedSvgWidth = this.$refs.displayed_table.getBoundingClientRect().width - 10;
      } else {
        calculatedSvgWidth = 100;
      }

      // update this.svgWidth and this.svgHeight only when they are changed
      if (calculatedSvgWidth !== this.svgWidth) {
        this.svgWidth = calculatedSvgWidth;
      }
    },
    updateSvgLeftBorder: function() {
      let calculatedSvgLeftBorder = this.svgLeftBorder;
      
      if ((this.$refs.displayed_table_first_line !== undefined) && (this.$refs.displayed_table_first_line[0] !== undefined)) {
        calculatedSvgLeftBorder = this.$refs.displayed_table_first_line[0].getBoundingClientRect().x;
      }

      // update this.svgLeftBorder only when it is changed
      if (calculatedSvgLeftBorder !== this.svgLeftBorder) {
        this.svgLeftBorder = calculatedSvgLeftBorder;
      }
    },
    updateCpaLineRefsBounds: function() {
      let calculatedCpaLineRefsBounds = this.cpaLineRefsBounds;
      
      const displayedCpaLineRefs = this.$refs.displayed_cpa_line;
      if (displayedCpaLineRefs !== undefined) {
        calculatedCpaLineRefsBounds = displayedCpaLineRefs.map(displayedCpaLineRef => {
          const displayedCpaLineRefBounds = displayedCpaLineRef.getBoundingClientRect();
          return {
            x: displayedCpaLineRefBounds.x,
            y: displayedCpaLineRefBounds.y,
            width: displayedCpaLineRefBounds.width,
            height: displayedCpaLineRefBounds.height
          };
        })
      }

      // update this.cpaLineRefsBounds only when it is changed
      let arrayModified = (this.cpaLineRefsBounds.length !== calculatedCpaLineRefsBounds.length);
      this.cpaLineRefsBounds.forEach((point, pointIndex) => {
        if (calculatedCpaLineRefsBounds[pointIndex] === undefined) {
          arrayModified = true; 
        } else if ((calculatedCpaLineRefsBounds[pointIndex].x !== point.x)
                  || (calculatedCpaLineRefsBounds[pointIndex].y !== point.y)
                  || (calculatedCpaLineRefsBounds[pointIndex].width !== point.width)
                  || (calculatedCpaLineRefsBounds[pointIndex].height !== point.height)) {
          arrayModified = true;
        }
      });
      if (arrayModified) {
        this.cpaLineRefsBounds = calculatedCpaLineRefsBounds;
      }
    },
    updateThHeaderDivMinHeight: function() {
      if (this.$refs.th_header_div !== undefined) {
        const thHeaderDivMinHeightCalculated = this.$refs.th_header_div.map((elem) => {
          return elem.getBoundingClientRect().width > 0 ? elem.getBoundingClientRect().height : 0
        }).reduce((previousValue, currentValue) => {
          return (previousValue > currentValue) ? previousValue : currentValue;
        }, 0);
        if (thHeaderDivMinHeightCalculated !== this.thHeaderDivMinHeight) {
          this.thHeaderDivMinHeight = thHeaderDivMinHeightCalculated;
        }
      }
    },
    updateThCtaDivMinHeight: function() {
      if (this.$refs.th_cta_div !== undefined) {
        const thCtaDivMinHeightCalculated = this.$refs.th_cta_div.map((elem) => {
          return elem.getBoundingClientRect().width > 0 ? elem.getBoundingClientRect().height : 0
        }).reduce((previousValue, currentValue) => {
          return (previousValue > currentValue) ? previousValue : currentValue;
        }, 0);
        if (thCtaDivMinHeightCalculated !== this.thCtaDivMinHeight) {
          this.thCtaDivMinHeight = thCtaDivMinHeightCalculated;
        }
      }
    },
    updateThCpaDivMinHeight: function() {
      if (this.$refs.th_cpa_div !== undefined) {
        const thCpaDivMinHeightCalculated = this.$refs.th_cpa_div.map((elem) => {
          return elem.getBoundingClientRect().width > 0 ? elem.getBoundingClientRect().height : 0
        }).reduce((previousValue, currentValue) => {
          return (previousValue > currentValue) ? previousValue : currentValue;
        }, 0);
        if (thCpaDivMinHeightCalculated !== this.thCpaDivMinHeight) {
          this.thCpaDivMinHeight = thCpaDivMinHeightCalculated;
        }
      }
    },
    getIntDivision: function(a, b) {
      return ((a - (a % b)) / b);
    },
    isHover: function(objectCoordinates) {
      if ((this.hoverCoordinates !== undefined) && (objectCoordinates.columnId !== undefined)) {
        if ((objectCoordinates.rowId === undefined)) {
          // isHover test for column of table content
          if (this.hoverCoordinates.row === undefined) {
            const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId);
            return returnedValue;
          } else {
            return false;
          }
        } else {
          const returnedValue = [this.hoverCoordinates.column].includes(objectCoordinates.columnId) && [this.hoverCoordinates.row].includes(objectCoordinates.rowId);
          return returnedValue;
        }
      } else {
        return false;
      }
      
    },
    isHoverElement: function(line, lineIndex, columnIndex) {
      return this.isHover({'columnId': columnIndex}) || this.isHover({'columnId': columnIndex, 'rowId': lineIndex});
    },
    onMouseOver: function(line, lineIndex, columnIndex) {
      if (line === this.mouseHoverLine) {
        // do nothing
      } else if (line !== undefined) {
        this.mouseHoverLine = line;
        this.$emit('hover-changed', { row: lineIndex, column: columnIndex });
      }
    },
    onMouseLeave: function(line) {
      if (line === this.mouseHoverLine) {
        this.mouseHoverLine = undefined;
        this.$emit('hover-changed', undefined);
      } else {
        // do nothing
      }
    },
    onMouseOverHeader: function(columnIndex, columnLinkedIndex) {
      if (columnLinkedIndex === undefined) {
        this.$emit('hover-changed', { column: columnIndex });
      } else {
        this.$emit('hover-changed', { column: columnIndex, columnLinked: columnLinkedIndex });
      }
    },
    onMouseLeaveHeader: function() {
      this.mouseHoverLine = undefined;
      this.$emit('hover-changed', undefined);
    },
    isElementHiddenByFilter: function(element) {
      let isElementHidden = false;
      this.hiddenElementsFilter.byColumnSelector.forEach((hiddenElementColumnSelector) => {
        if (isElementHidden === false) {
          isElementHidden = this.areSameColumnSelectors(hiddenElementColumnSelector, { addedColumnIndex: element.addedColumnsPropertyIndex, initialColumnIndex: element.initialColumnIndex });
        }
      })
      return isElementHidden;
    },
    isHiddenByFilterElement: function(line, lineIndex, columnIndex, isHeader) {
      let elementCoordinates;
      elementCoordinates = {'columnId': columnIndex, 'rowId': lineIndex, 'isHeader': isHeader};
      return this.isCoordinatesHiddenByFilter(elementCoordinates);
    },
    isCoordinatesHiddenByFilter: function(objectCoordinates) {
      if (this.filterCoordinates === undefined) {
        return false;
      } else {
        let returnedIsHiddenByFilter = false;
        if (objectCoordinates.isHeader) {
          if (this.filterCoordinates.row === undefined) {
            if (this.filterCoordinates.columnLinked !== undefined) {
              returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
            } else {
              returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
            }
          }
        } else if (this.filterCoordinates.row !== undefined) {
          if (objectCoordinates.rowId !== undefined) {
            // filter on row only
            returnedIsHiddenByFilter = ![this.filterCoordinates.row].includes(objectCoordinates.rowId);
          } else if ((this.filterCoordinates.column !== undefined) && (!objectCoordinates.isHeader)) {
            // filter on columns only
            if (this.filterCoordinates.columnLinked !== undefined) {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) && [this.filterCoordinates.columnLinked].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
              }
            } else {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) || [this.filterCoordinates.column].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
              }
            }
          }
        } else if (this.filterCoordinates.column !== undefined) {
            // filter on columns only
            if (this.filterCoordinates.columnLinked !== undefined) {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) && [this.filterCoordinates.columnLinked].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
              }
            } else {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) || [this.filterCoordinates.column].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
              }
            }
          }
        return returnedIsHiddenByFilter;
      }
    },
    isHeaderLine: function(index) {
      let result = false;
      if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (this.headerPosition === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    isHeaderPositionWithoutHeaderLine: function(index) {
      let result = false;
      if ((this.hasHeader === false) && (this.headerPosition === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    downloadTableContentAsJson: function() {
      let tableContentAsJsonData = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.downloadTableMatrix.getRows(), undefined, 2));
      const downloadHtmlElement = document.createElement('a');
      downloadHtmlElement.setAttribute('href', tableContentAsJsonData);
      downloadHtmlElement.setAttribute('download', this.tableContentDisplayerTitle + '.json');
      document.body.appendChild(downloadHtmlElement);
      downloadHtmlElement.click();
      downloadHtmlElement.remove();
    },
    downloadTableContentAsCsv: function() {
      let tableContentAsCsvData = "data:text/csv;charset=utf-8," + encodeURIComponent(this.downloadTableMatrix.getRows().map((rowContent) => {
        return rowContent.map(c => `"${c}"`).join(';');
      }).join('\n'));
      const downloadHtmlElement = document.createElement('a');
      downloadHtmlElement.setAttribute('href', tableContentAsCsvData);
      downloadHtmlElement.setAttribute('download', this.tableContentDisplayerTitle + '.csv');
      document.body.appendChild(downloadHtmlElement);
      downloadHtmlElement.click();
      downloadHtmlElement.remove();
    },
    updateSvgHeight: function(updatedHeight) {
      this.svgHeight = updatedHeight;
    },
    saveAdditionalContent: function() {
      console.log("[saveAdditionalContent] -~~-> save-additional-content");
      this.$emit('save-additional-content', {});
    },
    removeAdditionalContent: function() {
      console.log("[removeAdditionalContent] -~~-> remove-additional-content");
      this.$emit('remove-additional-content', {});
    },
    increasePolicySizeClass: function() {
      switch(this.policySizeClass) {
        case "xl":
        case "lg":
          this.policySizeClass = "xl";
          break;
        case "md":
          this.policySizeClass = "lg";
          break;
        case "sm":
          this.policySizeClass = "md";
          break;
        case "xs":
          this.policySizeClass = "md";
          break;
        default:
          this.policySizeClass = "xl";
          break;
      }
    },
    reducePolicySizeClass: function() {
      switch(this.policySizeClass) {
        case "xl":
          this.policySizeClass = "lg";
          break;
        case "lg":
          this.policySizeClass = "md";
          break;
        case "md":
          this.policySizeClass = "sm";
          break;
        case "sm":
        case "xs":
          this.policySizeClass = "xs";
          break;
        default:
          this.policySizeClass = "xs";
          break;
      }
    }
  }
};
</script>
<style scoped>

table.headerAlwaysVisible thead,
table.headerAlwaysVisible th {
  z-index: 4;
  position: sticky;
  top: 0px;
  background-color: whitesmoke;
}

table.headerAlwaysVisible thead:hover {
  z-index: 2
}

table.headerAlwaysVisible th {
  z-index: 1;
  position: inherit;
}

table.headerAlwaysVisible thead .dropdown-menu,
table.headerAlwaysVisible th .dropdown-menu {
  position: absolute;
  z-index: 5;
}


table.headerAlwaysVisible th.th-header-name {
  min-width: 40px;
}

.table-xs td, .table-xs th {
  padding: .2625rem .2625rem calc(.2625rem + 1px);
}

.custom-small-border-top {
  border-top-width: 0.156rem !important;
}

.smaller-font-size {
  font-size: smaller;
}

.hoverElement {
  background: lavender;
}

.icon-image::before {
  background-repeat: no-repeat;
  background-size: 27.5px;
  display: block;
  content: "";
  width: 27.5px;
  height: 27.6px;
}

.icon-image-delete-in-cloud::before {
  background-image: url("../../../assets/Delete-cloud-content.svg");
}

.icon-image-save-in-cloud::before {
  background-image: url("../../../assets/Cloud_backup_19371.svg");
}

.icon.icon-zoom-in,
.icon.icon-zoom-out {
  font-size: 20px !important
}

.icon.icon-Link {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
}  

.card.card-resizable-policy .icon {
  height: auto;
  width: auto;
}

.hidden-column {
  width: 1px;
  padding-left: 3px;
  margin-left: 2px;
}

.border.border-300.hidden-cell {
  padding-right: 2px;
  padding-left: 2px;
}

</style>